export default "__VITE_ASSET__CCy99TWw__"